import { Box, styled } from '@mui/material';
import { Button } from '@sb/cc-design-system';

export const BORDER_SIZE = 40;

export const ScreenWrapper = styled(Box)(
  ({ $height, $width, $zoom, $hasRightBorder, $isFirstVisible }) => `
  position: relative;
  width: ${
    ($width + BORDER_SIZE + ($hasRightBorder ? BORDER_SIZE : 0)) * $zoom
  }px;
  height: ${($height + BORDER_SIZE * 2) * $zoom}px;
  overflow: hidden;
  flex: 0 0 auto;
  margin-left: ${$isFirstVisible ? 0 : '-1px'};
  `,
);

export const ScreenScaleLayer = styled(Box)(
  ({ theme, $height, $width, $zoom, $hasRightBorder }) => `
  position: relative;
  width: ${$width}px;
  height: ${$height}px;
  box-sizing: content-box;
  border: ${BORDER_SIZE}px solid ${theme.colorPalette.neutral.text.primary};
  ${$hasRightBorder ? '' : `border-right: none;`}
  background: radial-gradient(#2c2c2c, ${
    theme.colorPalette.neutral.text.primary
  });
  transform: scale(${$zoom});
  transform-origin: top left;
  will-change: transform;
  `,
);

export const ScreenContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SectionContainer = styled(Box)(({ $dimmed }) => ({
  overflow: 'hidden',
  position: 'absolute',
  ...($dimmed && {
    opacity: 0.3,
  }),
  '& *': {
    boxSizing: 'unset',
  },
}));

export const PreviewPositionLayer = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== '$visible',
})<{ $visible: boolean }>(({ $visible }) =>
  $visible
    ? {}
    : {
        position: 'absolute',
        inset: 0,
        opacity: 0,
        pointerEvents: 'none',
      },
);

export const PreviewWrapper = styled(Box)(({ $isOverflowX, $isOverflowY }) => ({
  display: 'flex',
  justifyContent: $isOverflowX ? 'flex-start' : 'center',
  alignItems: $isOverflowY ? 'flex-start' : 'center',
  width: '100%',
  flex: 1,
  minHeight: 0,
  height: '100%',
  overflow: 'auto',
}));

export const ScreenLabelButton = styled(Button)`
  margin-bottom: 16px;
  .MuiButton-endIcon svg {
    color: #0000008f;
    width: 16px;
    height: 20px;
  }
`;
